import PropTypes from "prop-types"

const Stats = ({ total = 0, available = 0, booked = 0, disabled = 0, attended = 0, absent = 0 }) => (
  <div className="flex items-center justify-between gap-3 my-4">
    <div className="flex flex-col flex-grow p-3 text-center border-l-8 border-indigo-400 rounded-md shadow-lg bg-content1">
      <span className="text-3xl font-semibold">{total}</span>
      <span className="text-sm">Total</span>
    </div>

    <div className="flex flex-col flex-grow p-3 text-center border-l-8 rounded-md shadow-lg bg-content1 border-available">
      <span className="text-3xl font-semibold">{available}</span>
      <span className="text-sm">Available</span>
    </div>
    
    <div className="flex flex-col flex-grow p-3 text-center border-l-8 rounded-md shadow-lg bg-content1 border-booking">
      <span className="text-3xl font-semibold">{booked}</span>
      <span className="text-sm">Booked</span>
    </div>

    <div className="flex flex-col flex-grow p-3 text-center border-l-8 rounded-md shadow-lg bg-content1 border-disabled">
      <span className="text-3xl font-semibold">{disabled}</span>
      <span className="text-sm">Disabled</span>
    </div>

    <div className="flex flex-col flex-grow p-3 text-center border-l-8 rounded-md shadow-lg bg-content1 border-attended">
      <span className="text-3xl font-semibold">{attended}</span>
      <span className="text-sm">Attended</span>
    </div>

    <div className="flex flex-col flex-grow p-3 text-center border-l-8 rounded-md shadow-lg bg-content1 border-absent">
      <span className="text-3xl font-semibold">{absent}</span>
      <span className="text-sm">Absent</span>
    </div>
  </div>
)

Stats.propTypes = {
  total: PropTypes.number,
  attended: PropTypes.number,
  absent: PropTypes.number,
  available: PropTypes.number,
  booked: PropTypes.number,
  disabled: PropTypes.number
}

export default Stats